"use strict";

exports.__esModule = true;
exports.LandingScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Toolbar = require("../Core/Toolbar");
var _DomainName = require("./DomainName");
var _AppList = require("./AppList");
var _Screen = require("../Core/Screen");
var _Translator = require("../Core/Translator");
var _RestAPI = require("../API/RestAPI");
var _AppNavbar = require("../App/AppNavbar");
var _Theme = require("../Theme");
var _AIChatDialog = _interopRequireDefault(require("../Chat/AI/AIChatDialog"));
var _Auth = require("../Auth");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AppBar = _styledComponents["default"].div.attrs({
  className: "app-bar"
}).withConfig({
  displayName: "LandingScreen__AppBar",
  componentId: "sc-1pah5bx-0"
})(["display:flex;flex-direction:row;flex:1;justify-content:space-between;position:absolute;width:100%;.settings-menu-container{padding:", ";position:absolute;right:30px;top:20px;transform:scale(1.4);.settings-button.", "{box-shadow:none;background:none;&:hover,&:focus{background-color:#ffffff24;}}.settings-button path{fill:", ";}}.ai-chat-button-container{padding:", ";position:absolute;right:60px;top:20px;transform:scale(1.4);.ai-chat-button{box-shadow:none;background:none;&:hover,&:focus{background-color:#ffffff24;}}.ai-chat-button path{fill:", ";}}"], function (props) {
  return props.theme.LandingScreenSettingsIconPadding;
}, _core.Classes.BUTTON, (0, _Theme.val)("SettingsIconColor"), function (props) {
  return props.theme.LandingScreenSettingsIconPadding;
}, (0, _Theme.val)("SettingsIconColor"));
var Right = (0, _styledComponents["default"])(_Toolbar.RightToolbarContent).withConfig({
  displayName: "LandingScreen__Right",
  componentId: "sc-1pah5bx-1"
})(["align-items:center;"]);
var AppContainer = _styledComponents["default"].div.attrs({
  className: "app-container"
}).withConfig({
  displayName: "LandingScreen__AppContainer",
  componentId: "sc-1pah5bx-2"
})(["max-width:900px;justify-content:center;margin:auto;color:", ";"], function (props) {
  return props.theme.color;
});
var Logo = _styledComponents["default"].div.attrs({
  className: "logo"
}).withConfig({
  displayName: "LandingScreen__Logo",
  componentId: "sc-1pah5bx-3"
})(["position:relative;max-width:490px;min-width:300px;text-align:center;margin:40px auto 10px auto;img{max-width:100%;}"]);
var LandingPage = _styledComponents["default"].div.attrs({
  className: "landing-page"
}).withConfig({
  displayName: "LandingScreen__LandingPage",
  componentId: "sc-1pah5bx-4"
})(["background:", ";color:", ";background-size:contain;"], function (props) {
  return props.theme.AppHomeScreenBackground;
}, function (props) {
  return props.theme.LandingPageTextColor;
});
var SwitchPlantButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "LandingScreen__SwitchPlantButton",
  componentId: "sc-1pah5bx-5"
})(["flex:1;display:flex;align-items:center;margin:auto;"]);
var LandingScreen = exports.LandingScreen = function LandingScreen(_ref) {
  var appsList = _ref.appsList,
    _ref$showSwitchPlant = _ref.showSwitchPlant,
    showSwitchPlant = _ref$showSwitchPlant === void 0 ? false : _ref$showSwitchPlant;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var _React$useContext = _react["default"].useContext(_AppNavbar.NavbarSettingsMenuContext),
    SettingsMenu = _React$useContext.settingsMenu,
    setIsSwitchPlantOpen = _React$useContext.setIsSwitchPlantOpen;
  var _React$useContext2 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext2.translate;
  // $FlowFixMe
  var _React$useContext3 = _react["default"].useContext(_RestAPI.RestAPIContext),
    plantName = _React$useContext3.plantName;
  return /*#__PURE__*/_react["default"].createElement(_Screen.Screen, {
    title: translate("AppHomeScreen.title", "Home"),
    className: "AppHomeScreen " + theme.bodyClassName
  }, /*#__PURE__*/_react["default"].createElement(LandingPage, {
    className: "AppHomeScreen_Container",
    style: {
      display: "flex",
      flex: "1",
      height: "100vh"
    }
  }, /*#__PURE__*/_react["default"].createElement(AppBar, null, /*#__PURE__*/_react["default"].createElement(_DomainName.DomainName, {
    name: plantName
  }), /*#__PURE__*/_react["default"].createElement(Right, null, /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
    permission: "AI_CHAT"
  }, function (_ref2) {
    var isAllowed = _ref2.isAllowed;
    if (isAllowed) {
      return /*#__PURE__*/_react["default"].createElement(_AIChatDialog["default"], null);
    } else {
      return null;
    }
  }), /*#__PURE__*/_react["default"].createElement(SettingsMenu, {
    onSwitchPlantDialog: function onSwitchPlantDialog(isOpen) {
      return setIsSwitchPlantOpen(isOpen);
    }
  }))), /*#__PURE__*/_react["default"].createElement(AppContainer, null, /*#__PURE__*/_react["default"].createElement(Logo, null, /*#__PURE__*/_react["default"].createElement("img", {
    src: theme.LandingLogo.slice(4, -1),
    alt: "Logo"
  })), !showSwitchPlant ? appsList && /*#__PURE__*/_react["default"].createElement(_AppList.AppList, {
    appsList: appsList
  }) : /*#__PURE__*/_react["default"].createElement(SwitchPlantButton, {
    text: translate("SettingsMenu.switchPlant.title", "Switch Plant"),
    onClick: function onClick() {
      return setIsSwitchPlantOpen(true);
    }
  }))));
};